import React from 'react';

const GA4_KEY = process.env.REACT_APP_GA4;

function Header() {
    React.useEffect(() => {
        const script1 = document.createElement('script');
        script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_KEY}`;
        script1.async = true;
        document.head.appendChild(script1);

        const script2 = document.createElement('script');
        script2.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${GA4_KEY}');
        `;
        document.head.appendChild(script2);
    }, []);

    return (
        <></>
    );
}

export default Header;